import {
  extractAgentModeSwitch,
  hasCompleteAnswerEnvelope,
  stripAnswerEnvelope,
  stripAnswerMarkers
} from '@atbash-labs/ontology-agent-wire'

export {
  extractAgentModeSwitch,
  hasCompleteAnswerEnvelope,
  stripAnswerEnvelope,
  stripAnswerMarkers
}

const ANSWER_START = '<answer_start>'

/**
 * Return the answer inside a streaming answer envelope, or `null` when the
 * text is an ordinary progress note. An empty string means the start marker
 * has arrived but no answer text has streamed yet.
 *
 * Body extraction (including preamble before `<answer_start>` and residual
 * close tags like `<answer_end>` / `</answer_end>`) is shared with
 * `stripAnswerEnvelope`.
 */
export function extractStreamingAnswer(text: string): string | null {
  if (!text.toLowerCase().includes(ANSWER_START)) return null
  return stripAnswerEnvelope(text)
}
